import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import { apiFetch } from '../lib/api'
import type { User } from '@fellowship/shared'

/**
 * Landing page for Google OAuth callback.
 * The API redirects here with ?accessToken=...&refreshToken=...
 * We store them and redirect the user.
 */
export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const { setTokens, setOnboardingComplete } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    const accessToken = searchParams.get('accessToken')
    const refreshToken = searchParams.get('refreshToken')

    if (!accessToken || !refreshToken) {
      navigate('/login')
      return
    }

    // Fetch the user profile with the new token before storing
    void apiFetch<{ data: User }>('/users/me', {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then(({ data }) => {
        setTokens(accessToken, refreshToken, data)
        if (data.locationLat) setOnboardingComplete()
        if (!data.locationLat) {
          navigate('/onboarding')
        } else if (data.churchSlug) {
          navigate(`/churches/${data.churchSlug}/dashboard`)
        } else {
          navigate('/app')
        }
      })
      .catch(() => {
        navigate('/login')
      })
  }, []) // run once on mount — params are stable from URL

  return (
    <main className="flex min-h-screen items-center justify-center bg-fellowship-50">
      <p className="text-sm text-fellowship-600">Signing you in…</p>
    </main>
  )
}
